import React from "react";
import "./Modal.css";

const Modal = (props) => {
  return (
    <>
      <div onClick={props.hideModalNow} className="backdrop"></div>
      <div className="modal">
        <p>Contact Me</p>
        <p onClick={props.hideModalNow} className="cross">
          x
        </p>
        <form
          action="https://formspree.io/f/mknavqjq"
          name="contact"
          method="POST"
        >
          <input type="hidden" name="form-name" value="contact" />
          <label htmlFor="name">Name</label>
          <input name="full-name" id="name" type="text" required />
          <label htmlFor="email">Email</label>
          <input name="email" id="email" type="email" required />
          <label htmlFor="comment">Comments</label>
          <input name="comment" id="comment" type="text" required />

          <button type="submit" className="modal-btn">
            Submit
          </button>
        </form>
      </div>
    </>
  );
};

export default Modal;
